import { SxProps } from "@mui/material";
import { CommonStyles } from "@styles/common-styles";
import { Alert, FaroText } from "@faro-lotv/flat-ui";

interface ExpirationAlertProps {
  /** description to display in the alert */
  description: string;
  
  /** custom styles to apply to the alert */
  customSx?: SxProps;
}

/**
 * Displays an alert to notify the user about the expiration of their subscription
 */
export function SubscriptionExpirationAlert({ description, customSx }: ExpirationAlertProps): JSX.Element {
  return (
      <Alert
        title={
           <FaroText
            variant="heading12"
            >
              {description}
            </FaroText>
          }
          variant="warning"
          sx={{
            height: "40px",
            padding: "0px 20px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "20px",
            borderBottom: CommonStyles.Borders.gray200Divider,
            borderTop: CommonStyles.Borders.gray200Divider,
            ...customSx,
          }}
      />
  );
}